import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitoalibaugcab() {



  const cardData =
  {
    keyword: 'Mumbai to Alibaug Cab',
    heading: 'Shambhu Cabs: Mumbai to Alibaug Cab  ',
    headingDescription: 'Shambhu Cabs offers reliable Mumbai to Alibaug Cab services, providing safe, comfortable, and hassle-free travel for families, friends, corporate travelers, and weekend getaway enthusiasts. Our fleet of hatchbacks, sedans, SUVs, and tempo travellers ensures a smooth and enjoyable journey from Mumbai to the beautiful coastal town of Alibaug with well-maintained vehicles and spacious seating. With flexible one-way and round-trip options, experienced chauffeurs, and 24/7 booking support, Shambhu Cabs makes your trip stress-free and convenient. From South Mumbai to Thane, Andheri to Vashi, Shambhu Cabs provides doorstep pickup and trusted Mumbai to Alibaug cab services for travelers seeking comfort, safety, and a memorable travel experience.',

    top: 'Top Places to Visit in Alibaug with Shambhu Cabs',

 "topPlaces": [
  {
    "title": "Alibaug Beach",
    "description": "Alibaug Beach is a popular coastline known for its soft sands, calm waves, and beautiful sunsets. It is ideal for leisurely walks, beach sports, and enjoying local food from nearby stalls. The beach is also famous for its vibrant atmosphere during weekends and festivals."
  },
  {
    "title": "Kolaba Fort",
    "description": "Kolaba Fort is a historic sea fort located a short walk from Alibaug Beach during low tide. Built by Shivaji Maharaj, the fort features strong fortifications, ancient cannons, and panoramic views of the Arabian Sea, making it a must-visit for history and photography enthusiasts."
  },
  {
    "title": "Kihim Beach",
    "description": "Kihim Beach is known for its serene environment, coconut groves, and migratory bird sightings. It is less crowded than Alibaug Beach, making it perfect for quiet relaxation, nature walks, and bird photography."
  },
  {
    "title": "Nagaon Beach",
    "description": "Nagaon Beach is a pristine, sandy beach famous for water sports such as jet skiing, banana boat rides, and parasailing. The beach is lined with resorts and restaurants, making it an ideal spot for adventure seekers and families alike."
  },
  {
    "title": "Varsoli Beach",
    "description": "Varsoli Beach is a clean and peaceful beach near Alibaug town. Known for its calm waters and coconut palms, it is perfect for picnics, evening walks, and enjoying quiet sunsets away from the main tourist crowd."
  },
  {
    "title": "Korlai Fort",
    "description": "Korlai Fort, also called Corlim Fort, is a Portuguese-built fort with a rich history and commanding views of the Arabian Sea. The fort is surrounded by a small fishing village, offering a glimpse of local culture alongside historical exploration."
  },
  {
    "title": "Mandwa Beach",
    "description": "Mandwa Beach is popular for its ferry services connecting Alibaug to Mumbai. The beach is ideal for long walks, water sports, and enjoying seafood at nearby stalls. It is also a hub for day-trippers from Mumbai."
  },
  {
    "title": "Akshi Beach",
    "description": "Akshi Beach is a secluded and serene beach surrounded by coconut trees and open shores. It is less commercialized, offering peaceful sunset views, photography opportunities, and a relaxing escape into nature."
  },
  {
    "title": "Phansad Wildlife Sanctuary",
    "description": "Phansad Wildlife Sanctuary is located near Alibaug and is home to diverse flora and fauna, including leopards, deer, and numerous bird species. The sanctuary offers trekking trails and nature walks, making it perfect for wildlife enthusiasts and eco-tourists."
  },
  {
    "title": "Revdanda Beach & Fort",
    "description": "Revdanda Beach is known for its long shoreline and peaceful ambiance, while Revdanda Fort stands nearby as a historical landmark built by the Portuguese. The combination of beach and fort offers a unique experience of history and natural beauty."
  }
],


"services": [
  {
    "name": "Mumbai Alibaug Taxi",
    "description": "Mumbai Alibaug Taxi provides reliable and comfortable transportation between Mumbai and Alibaug. The service offers well-maintained vehicles, professional drivers familiar with the Mumbai–Alibaug route, and flexible scheduling options. Ideal for families, couples, and solo travelers, it ensures a safe, smooth, and enjoyable journey along scenic coastal roads and highways."
  },
  {
    "name": "Alibaug Beach Cab Mumbai",
    "description": "Alibaug Beach Cab Mumbai specializes in trips to the famous beaches of Alibaug, including Alibaug, Nagaon, and Kashid. Vehicles are clean, comfortable, and driven by experienced chauffeurs who know the best routes. Passengers can enjoy a hassle-free, scenic ride perfect for weekend getaways, family trips, or romantic beach outings from Mumbai."
  },
  {
    "name": "Gateway to Alibaug Cab",
    "description": "Gateway to Alibaug Cab offers convenient and seamless travel options for passengers heading to Alibaug via the Mumbai coastal route and Mandwa jetty. Comfortable sedans and SUVs, professional drivers, and on-time service make it ideal for leisure trips, group outings, and corporate travel. Passengers can enjoy a safe and smooth journey while taking in the scenic coastal views."
  },
  {
    "name": "Mumbai to Alibaug Car Rental",
    "description": "Mumbai to Alibaug Car Rental provides flexible vehicle hire options for travelers seeking self-planned trips or chauffeur-driven services. A variety of sedans, SUVs, and premium cars are available to meet different group sizes and travel preferences. The service ensures comfort, reliability, and convenience for family vacations, weekend escapes, and sightseeing tours."
  },
  {
    "name": "One-Way Cab Mumbai Alibaug",
    "description": "One-Way Cab Mumbai Alibaug is ideal for travelers who need a single-direction ride from Mumbai to Alibaug. Perfect for short trips, hotel check-ins, or personal errands, the service provides professional drivers, clean vehicles, and competitive pricing. Passengers can enjoy a stress-free and efficient journey without worrying about return travel."
  },
  {
    "name": "Affordable Alibaug Cab Mumbai",
    "description": "Affordable Alibaug Cab Mumbai offers budget-friendly options for passengers traveling between Mumbai and Alibaug. Vehicles are well-maintained and driven by skilled drivers, ensuring safety and comfort without exceeding travel budgets. Ideal for students, small families, and weekend travelers seeking economical yet reliable transport."
  },
  {
    "name": "Best Taxi Mumbai Alibaug",
    "description": "Best Taxi Mumbai Alibaug is known for premium service, punctuality, and excellent customer support. Well-maintained vehicles, professional drivers, and flexible scheduling make it perfect for tourists, business travelers, and families. Passengers can enjoy a smooth, safe, and memorable journey to Alibaug with personalized attention and comfort."
  },
  {
    "name": "SUV Cab Mumbai Alibaug",
    "description": "SUV Cab Mumbai Alibaug caters to groups and families needing spacious and comfortable vehicles for travel from Mumbai to Alibaug. Equipped with modern amenities, air-conditioning, and safety features, these SUVs ensure a relaxing journey for long drives or weekend trips, while professional drivers handle the route with expertise."
  },
  {
    "name": "Sedan Cab Mumbai Alibaug",
    "description": "Sedan Cab Mumbai Alibaug offers efficient, economical, and comfortable sedans for solo travelers, couples, or small families. Professional drivers and well-maintained vehicles provide a safe and hassle-free journey from Mumbai to Alibaug, making it ideal for short trips, beach visits, and day outings."
  },
  {
    "name": "Mumbai to Mandwa Jetty Cab",
    "description": "Mumbai to Mandwa Jetty Cab provides convenient transportation to the Mandwa jetty for travelers heading to Alibaug via ferry. The service includes comfortable vehicles, experienced drivers, and on-time pickups. Ideal for tourists and weekend travelers, it ensures a smooth and coordinated transfer from Mumbai to the jetty and onward to Alibaug."
  },
  {
    "name": "24×7 Mumbai Alibaug Cab",
    "description": "24×7 Mumbai Alibaug Cab ensures round-the-clock taxi services for passengers traveling anytime between Mumbai and Alibaug. Vehicles are always ready, drivers are professional and punctual, and flexible pickup/drop options are provided. This service is perfect for early departures, late-night travel, and emergency trips with safety and comfort guaranteed."
  },
  {
    "name": "Mumbai Alibaug Outstation Cab",
    "description": "Mumbai Alibaug Outstation Cab focuses on long-distance travel for passengers heading from Mumbai to Alibaug and surrounding areas. Comfortable sedans and SUVs, professional chauffeurs, and flexible schedules ensure a smooth journey. Ideal for family trips, corporate travel, and weekend getaways, it guarantees convenience, safety, and a stress-free experience."
  },
  {
    "name": "Family Trip Cab Mumbai Alibaug",
    "description": "Family Trip Cab Mumbai Alibaug specializes in travel for families and small groups, offering spacious vehicles, experienced drivers, and flexible itineraries. Passengers can enjoy sightseeing, beach visits, and relaxed journeys with complete comfort and safety. Perfect for vacations, weekend escapes, and family outings from Mumbai."
  },
  {
    "name": "Fast Cab Mumbai Alibaug",
    "description": "Fast Cab Mumbai Alibaug provides quick, efficient, and punctual travel between Mumbai and Alibaug. The service includes well-maintained vehicles, professional drivers, and direct routes to minimize travel time. Ideal for business travelers, urgent trips, or those wanting a time-efficient journey with complete comfort and reliability."
  },
  {
    "name": "Corporate Cab Mumbai Alibaug",
    "description": "Corporate Cab Mumbai Alibaug offers professional transportation solutions for business travelers and corporate groups. Premium sedans and SUVs, experienced drivers, and flexible schedules ensure timely and comfortable travel. This service is suitable for meetings, corporate retreats, and VIP transfers to Alibaug from Mumbai."
  },
  {
    "name": "Premium Cab Mumbai Alibaug",
    "description": "Premium Cab Mumbai Alibaug provides high-end travel options with luxury vehicles, professional chauffeurs, and superior service standards. Ideal for executives, families, and tourists seeking comfort and style, this service ensures a smooth, secure, and elegant journey from Mumbai to Alibaug."
  },
  {
    "name": "Safe Taxi Mumbai Alibaug",
    "description": "Safe Taxi Mumbai Alibaug emphasizes passenger safety, well-maintained vehicles, and professional drivers trained for long-distance travel. Ideal for families, solo travelers, and corporate clients, the service ensures a secure, comfortable, and reliable journey from Mumbai to Alibaug with peace of mind."
  }
],

"tableData": [
  ["Mumbai Alibaug Taxi", "Alibaug Beach Cab Mumbai"],
  ["Gateway to Alibaug Cab", "Mumbai to Alibaug Car Rental"],
  ["One-Way Cab Mumbai Alibaug", "Affordable Alibaug Cab Mumbai"],
  ["Best Taxi Mumbai Alibaug", "SUV Cab Mumbai Alibaug"],
  ["Sedan Cab Mumbai Alibaug", "Mumbai to Mandwa Jetty Cab"],
  ["24×7 Mumbai Alibaug Cab", "Mumbai Alibaug Outstation Cab"],
  ["Family Trip Cab Mumbai Alibaug", "Fast Cab Mumbai Alibaug"],
  ["Corporate Cab Mumbai Alibaug", "Premium Cab Mumbai Alibaug"],
  ["Safe Taxi Mumbai Alibaug", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Mumbai to Alibaug Cab with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers reliable Mumbai to Alibaug cab services, perfect for beach trips, weekend getaways, and comfortable long-distance travel."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in spacious, air-conditioned, and regularly serviced cabs to enjoy a smooth and relaxing journey to Alibaug."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Coastal and Highway Routes",
    "WhyChoosedescription": "Our professional drivers are familiar with the Mumbai to Alibaug route, ensuring safe, timely, and comfortable travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy clear and upfront pricing—fuel, tolls, and driver allowances included—making your Mumbai to Alibaug cab trip hassle-free."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available around the clock to assist with bookings, travel queries, and route guidance."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans for Weekend Travel",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized rental plans tailored to your Mumbai to Alibaug travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a hygienic and safe travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and smooth service, making your Mumbai to Alibaug journey stress-free and comfortable."
  }
]




















  }

const faqData = [
  {
    question: 'Does Shambhu Cabs offer Mumbai to Alibaug cab services?',
    answer: 'Yes, Shambhu Cabs provides reliable and comfortable Mumbai to Alibaug cab services with experienced and professional drivers.',
  },
  {
    question: 'How can I book a Mumbai to Alibaug cab with Shambhu Cabs?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 customer support team for quick assistance.',
  },
  {
    question: 'What types of vehicles are available for Mumbai to Alibaug cab bookings?',
    answer: 'Shambhu Cabs offers well-maintained sedans, SUVs, and luxury cars suitable for a safe and comfortable trip from Mumbai to Alibaug.',
  },
  {
    question: 'Are drivers experienced for the Mumbai to Alibaug route?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with the Mumbai to Alibaug route to ensure a smooth and safe journey.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations for my Mumbai to Alibaug cab?',
    answer: 'Absolutely. You can select your preferred pickup point in Mumbai and drop-off location anywhere in Alibaug.',
  },
  {
    question: 'Is the Mumbai to Alibaug cab service available 24x7 with Shambhu Cabs?',
    answer: 'Yes, Shambhu Cabs offers round-the-clock Mumbai to Alibaug cab booking services to suit your travel schedule.',
  },
  {
    question: 'Are safety and hygiene measures followed for Mumbai to Alibaug cab bookings?',
    answer: 'All vehicles are sanitized regularly, and drivers follow strict safety and hygiene protocols for passenger well-being.',
  },
  {
    question: 'What payment options are available for Mumbai to Alibaug cab bookings?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate account payments.',
  },
  {
    question: 'Is customer support available during the Mumbai to Alibaug journey?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your Mumbai to Alibaug travel.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit Sharma',
    feedback: 'Our Mumbai to Alibaug trip with Shambhu Cabs was smooth and enjoyable. The driver was punctual and the car clean.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Ananya Patil',
    feedback: 'Highly reliable Mumbai to Alibaug cab service. Comfortable ride and excellent support from Shambhu Cabs.',
    rating: 5,
  },
];














































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Alibaug Cab",
  "image": "https://www.shambhucab.com/assets/images/mumbai-to-alibaug-cab.jpg",
  "description": "Shambhu Cabs offers reliable Mumbai to Alibaug cab services for comfortable travel to Alibaug beaches, Mandwa Jetty, and coastal trips. Book sedans, SUVs, or premium cars for one-way, round-trip, family, or corporate travel. Enjoy safe, fast, and affordable cab services available 24×7.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5300",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2500",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-to-alibaug-cab"
  }
};







  return (
    <div>
<Helmet>
  <title>Mumbai to Alibaug Cab | Beach & Outstation Taxi | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book Mumbai to Alibaug cab with Shambhu Cabs. Affordable, safe, and comfortable travel for Alibaug beaches, Mandwa Jetty, family trips, and corporate travel. Available 24×7 with sedan, SUV, and premium cars."
  />

  <meta
    name="keywords"
    content="Mumbai Alibaug Taxi, Alibaug Beach Cab Mumbai, Gateway to Alibaug Cab, Mumbai to Alibaug Car Rental, One-Way Cab Mumbai Alibaug, Affordable Alibaug Cab Mumbai, Best Taxi Mumbai Alibaug, SUV Cab Mumbai Alibaug, Sedan Cab Mumbai Alibaug, Mumbai to Mandwa Jetty Cab, 24×7 Mumbai Alibaug Cab, Mumbai Alibaug Outstation Cab, Family Trip Cab Mumbai Alibaug, Fast Cab Mumbai Alibaug, Corporate Cab Mumbai Alibaug, Premium Cab Mumbai Alibaug, Safe Taxi Mumbai Alibaug"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/12.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitoalibaugcab;